import { useEffect, useState } from "react";

export default function useResizeHandler() {
  const [windowSize, setWindowSize] = useState({
    width: null,
    height: null,
  });

  let resizeTimer = null;

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });
      }, 100);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}
